import { createContext, PropsWithChildren, useContext, useState } from "react";

interface Data {
  name: string;
  isNewsletter: boolean;
  requiresReview: boolean;
  tags: [];
  contentGroups: [];
  recipients: [];
}

interface ContextValue {
  data: Data;
  onSubmitData: (inputs: Partial<Data>) => void;
}

const initialDefaultValues: Data = {
  name: "",
  isNewsletter: false,
  requiresReview: false,
  tags: [],
  contentGroups: [],
  recipients: [],
};

const CreateListDataContext = createContext<ContextValue | undefined>(
  undefined
);

export function useCreateListData() {
  const value = useContext(CreateListDataContext);
  if (value === undefined) {
    throw new Error(
      "useCreateListData must be used within a CreateListDataContext"
    );
  }
  return value;
}

export function CreateListDataProvider({ children }: PropsWithChildren) {
  const [data, setData] = useState<Data>(initialDefaultValues);

  const onSubmitData = async (inputs: Partial<Data>) =>
    setData({ ...data, ...inputs });

  return (
    <CreateListDataContext.Provider
      value={{
        data,
        onSubmitData,
      }}
    >
      {children}
    </CreateListDataContext.Provider>
  );
}
